import Button from 'fuse-ui/components/Button';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import DomainGroupingFormContainer from './domain-grouping-form-container';
import Modal from '../../modal/modal';
import LoadingSpinner from '../../common/components/loading-spinner';
import Warning from '../../common/components/warning';

const styles = theme => {
    return  {
        button: {
            margin: theme.spacing.unit,
        },
        form: {
            zIndex: theme.zIndex.modal + 1
        },
        warningContainer: {
            margin: '0 -24px 8px -24px',
        }
    };
};

const DomainGroupingModal = ( {
    classes,
    editMode,
    isSaveDisabled,
    isUpdating,
    onDismiss,
    onSave,
    open,
    warnings
} ) => {
    const actions = (
        <>
            {
                !isUpdating && (
                <>
                    <Button
                        className={classes.button}
                        data-automation-id="domain-grouping-modal-cancel-btn"
                        onClick={onDismiss}
                        variant="text"
                    >
                        Cancel
                    </Button>
                    <Button
                        className={classes.button}
                        color="primary"
                        data-automation-id="domain-grouping-modal-save-btn"
                        disabled={isSaveDisabled}
                        onClick={onSave}
                    >
                        Save
                    </Button>
                </>
                ) }
        </>
    );

    const title = editMode ? 'Edit Domain Group' : 'Group Domains';

    return (
        <Modal
            dataAutomationId="domain-grouping-modal"
            open={open}
            title={title}
            modalActions={actions}
        >
            {
                warnings.map( ( message, index ) => {
                    return (
                        <div className={classes.warningContainer} key={index}>
                            <Warning color="textSecondary">{message}</Warning>
                        </div>
                    );
                } )

            }
            <div className={classes.form} >
                {
                    isUpdating ?
                        <LoadingSpinner /> :
                        <DomainGroupingFormContainer />
                }
            </div>
        </Modal>
    );

};

DomainGroupingModal.propTypes = {
    classes: PropTypes.object.isRequired,
    editMode: PropTypes.bool.isRequired,
    isSaveDisabled: PropTypes.bool,
    isUpdating: PropTypes.bool,
    onDismiss: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    warnings: PropTypes.array.isRequired
};

export default withStyles( styles )( DomainGroupingModal );
